export const environment = {
  production: true,
  url: 'http://localhost:3000/',
  // url: 'https://api.scriptdoor.org',
  //  url: 'https://beta.scriptdoor.org',
  // url: 'http://3.236.240.206',
  // url: 'https://api.scriptdoor.com',
  // socketUrl: 'http://localhost:27018/',
  socketUrl: 'https://chat.scriptdoor.com/',

  //Captcha
  scriptPath: 'https://api.leminnow.com/captcha/v1/cropped/CROPPED_d4f73eb_020a9dd212074d2f8d13516cec3299ca/js',

  aws: {
    IdentityPoolId: "ap-south-1:43654482-2b4c-47ac-94e2-1639f63abe34",
    region: 'ap-south-1',
    aws_bucket_name: 'scriptdoor-alpha',
    url: 'http://scriptdoor-alpha.s3-website.ap-south-1.amazonaws.com'
  },

  // aws: {
  //   aws_access_key_id: 'AKIATFR5C3SYEWOC47DB',
  //   aws_secret_access_key: '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',
  //   aws_bucket_name: 'scriptdoor-video-source-ni8cs9ho9jt1',
  //   s3_region: 'us-east-1',
  //   url: 'https://scriptdoor-video-source-ni8cs9ho9jt1.s3.amazonaws.com/'
  //   // url: 'https://scriptdoor-video-source-ni8cs9ho9jt1.s3-accelerate.amazonaws.com/'
  // },
  // oneSignal_appId: '99d07d14-cdea-4fba-86d6-87ae1c65bd30', <==============old one
  oneSignal_appId: '0492739f-983a-40ea-8296-647861bf3485',
  // beta key
  stripe_publication_key: 'pk_test_W6iy5gXeWlLIUgA98xzyZGBj00Q1Hq6lFx',
  stripe_secret_key: 'sk_test_vMTxaS8kjG5vOEWqoYysfZDK00M4GlQ2sC',
  chat_url: 'https://chat.scriptdoor.com/',
  // chat_url: 'http://localhost:27018/',
  chatToken : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2M2ZjOGFjZGY3ZjljZmU0NjE1MTA1ZTEiLCJuYW1lIjoiYXdzLXByb2QiLCJkb21haW4iOiJwcm9kLWF3cy5zY3JpcHRkb29yLmNvbSIsInN1YmRvbWFpbiI6ImF3cy1wcm9kIiwiX192IjowLCJpYXQiOjE2Nzc0OTQ5OTB9.pzpyEfQaSH2IoDADwaCeQBb1JE1BCIiYMUwSF4xEh1k',
};

// export const environment = {
//   production: true,
//   url: 'https://api-beta.scriptdoor.com',
//   // url: 'http://40.117.134.103',
//   // chatToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1ZWRjNmYzYjU0MGJjNjcwNjYxMTZmMTMiLCJuYW1lIjoiYmV0YS1henVyZSIsImRvbWFpbiI6ImJldGEtYXp1cmUuc2NyaXB0ZG9vci5jb20iLCJzdWJkb21haW4iOiJiZXRhLWF6dXJlIiwiX192IjowLCJpYXQiOjE1OTE1MDQ2OTl9.C5gE3UPAnBZ9S35KocsFlKqfhmTawoq5XNvkFHHxjeU',
//   chatToken:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MjU3YWYwYzUzMDc5MDI2NWExYzE1MmUiLCJuYW1lIjoiRGVtbyIsImRvbWFpbiI6Ind3dy5zY3JpcHRkb29yLmNvbSIsInN1YmRvbWFpbiI6ImRlbW8uc2NyaXB0ZG9vci5jb20iLCJfX3YiOjAsImlhdCI6MTY0OTkxMzYxMn0.D4MXZLceNRRGKapL5gLTcjTBGdJ-9twqWfL4RR-jlCQ',
//   // socketUrl: 'http://3.7.102.224:3000',
//   socketUrl: 'https://demo-chat.scriptdoor.com/',
//   userObj: {
//     "id": "5ea6720c22bb39336c7206a1",
//     "name": "mihir",
//     "username": "mihir",
//     "email": "mihir@gmail.com"
//   },
//   aws: {
//     aws_secret_access_key: '2DsRGLZiD0ct6k2LEdyKXQbz2WNwn89qPLYczacb',
//     aws_access_key_id: 'AKIAXV2QT5P6REZ7GMVP',
//     aws_bucket_name: 'scriptdoor-vod-beta-source-pv0ncye3aao5',
//     s3_region: 'ap-south-1',
//     url: 'https://scriptdoor-vod-beta-source-pv0ncye3aao5.s3.ap-south-1.amazonaws.com/'
//   },
//   oneSignal_appId: '6237ebc7-d75a-46f4-92af-b60ef00459e4',
//   stripe_publication_key: 'pk_test_W6iy5gXeWlLIUgA98xzyZGBj00Q1Hq6lFx',
//   stripe_secret_key: 'sk_test_vMTxaS8kjG5vOEWqoYysfZDK00M4GlQ2sC',
//   chat_url: 'http://13.235.232.157',
//   accountName: "scriptdoorassets",
//   key: "Zh3PyJi/72tNoC/CMFyUKv3Q0qzST41zNH6QONYOY8BRKFUQe2ZntAFi25iEzNfNCRx0d42igGy1fBCVNDIu5w==",
//   containerName: "assets",
// };
